/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useMaterialPickersStyles = makeStyles({
  popoverRoot: {
    '& .MuiPickersModalDialog-dialogContainer:focus > .MuiPickersModalDialog-dialogRoot': {
      outline: 'none',
    },
    '& .MuiPickersBasePicker-container': {
      '& .MuiPaper-rounded': {
        borderRadius: 0,
      },
      '& .MuiPaper-elevation1': {
        boxShadow: 'none',
      },
      '& .MuiTypography-h3': {
        fontSize: '48px',
        fontWeight: '400',
        letterSpacing: '-0.37px',
        lineHeight: '1.167',
      },
      '& .MuiTypography-subtitle1': {
        fontSize: '16px',
        lineHeight: '1.75',
        fontWeight: 400,
      },
      '& .MuiTypography-h4': {
        fontSize: '34px',
        lineHeight: '1.235',
        fontWeight: 400,
      },
      '& .MuiTypography-overline': {
        fontSize: '12px',
        lineHeight: '2.66',
        fontWeight: 400,
      },
      '& .MuiPickersClock-clock': {
        '& .MuiTypography-body1': {
          color: 'inherit',
          fontSize: '0.9285714285714286rem',
          fontWeight: '400',
          lineHeight: '1.5',
        },
        '& .MuiTypography-body2': {
          color: 'inherit',
          fontSize: '0.8125rem',
          fontWeight: '400',
          lineHeight: '1.43',
        },
      },
    },
  },
});
